import _ from 'lodash';

const getPassengerFlightSeats = (travelers, flightItinerary = null) => {
  const allFlights = flightItinerary ? _.filter(_.flatMap(
    flightItinerary.flightSegments,
    (seg) => seg.flights,
  ), (f) => f) : null;
  return _.flatMap(travelers || {}, (t) => {
    if (!t.travelerPreferences || !t.travelerPreferences.flightSeatNumbers) return [];

    if (!allFlights || allFlights.length === 0) {
      return Object.values(t.travelerPreferences.flightSeatNumbers);
    }
    const seats = [];
    Object.keys(t.travelerPreferences.flightSeatNumbers).forEach((key) => {
      if (_.find(allFlights, (f) => f.flightNumber === key)
      && t.travelerPreferences.flightSeatNumbers[key]) {
        seats.push(t.travelerPreferences.flightSeatNumbers[key]);
      }
    });
    return seats;
  });
};

export default getPassengerFlightSeats;
